import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(3),
    },
    summaryBox: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(1),
        padding: theme.spacing(2),
        border: `1px solid ${theme.palette.emteria.border.primary}`,
        borderRadius: theme.spacing(1),
        backgroundColor: theme.palette.emteria.background.paper,
    },
    row: {
        display: "flex",
        justifyContent: "space-between",
        gap: theme.spacing(1),
    },
    label: {
        color: theme.palette.emteria.text.secondary,
        flexShrink: 0,
    },
    value: {
        fontWeight: 500,
        textAlign: "right",
    },
    notesLabel: {
        marginBottom: theme.spacing(1),
    },
    content: {
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        overflow: "auto",
        padding: theme.spacing(3),
        paddingBottom: theme.spacing(1),
    },
    footer: {
        display: "flex",
        justifyContent: "space-between",
        gap: theme.spacing(1),
        padding: theme.spacing(2, 3),
        borderTop: `1px solid ${theme.palette.emteria.border.primary}`,
        flexShrink: 0,
    },
}));
